var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        padding: "0 10px",
        "max-height": "600px",
        "overflow-y": "auto",
        "overflow-x": "hidden",
      },
    },
    [
      _vm.linkItems.length === 0
        ? _c("div", [
            _c("p", { staticClass: "text-center" }, [
              _vm._v(
                '\n      No links added yet. Click the "Add" button to add a new link.\n    '
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.linkItems, function (linkItem, index) {
        return _c(
          "div",
          { key: index, staticClass: "mb-3" },
          [
            _c(
              "b-card",
              { attrs: { "bg-variant": "light" } },
              [
                _c(
                  "b-form-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "X" } },
                          [
                            _c("b-form-input", {
                              attrs: { type: "number" },
                              on: { input: _vm.updateResultData },
                              model: {
                                value: linkItem.x,
                                callback: function ($$v) {
                                  _vm.$set(linkItem, "x", $$v)
                                },
                                expression: "linkItem.x",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Y" } },
                          [
                            _c("b-form-input", {
                              attrs: { type: "number" },
                              on: { input: _vm.updateResultData },
                              model: {
                                value: linkItem.y,
                                callback: function ($$v) {
                                  _vm.$set(linkItem, "y", $$v)
                                },
                                expression: "linkItem.y",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Width" } },
                          [
                            _c("b-form-input", {
                              attrs: { type: "number" },
                              on: { input: _vm.updateResultData },
                              model: {
                                value: linkItem.width,
                                callback: function ($$v) {
                                  _vm.$set(linkItem, "width", $$v)
                                },
                                expression: "linkItem.width",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Height" } },
                          [
                            _c("b-form-input", {
                              attrs: { type: "number" },
                              on: { input: _vm.updateResultData },
                              model: {
                                value: linkItem.height,
                                callback: function ($$v) {
                                  _vm.$set(linkItem, "height", $$v)
                                },
                                expression: "linkItem.height",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "7" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Link" } },
                          [
                            _c("b-form-input", {
                              attrs: { type: "text" },
                              on: { input: _vm.updateResultData },
                              model: {
                                value: linkItem.link,
                                callback: function ($$v) {
                                  _vm.$set(linkItem, "link", $$v)
                                },
                                expression: "linkItem.link",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "4" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Add from page" } },
                          [
                            _c("b-form-input", {
                              attrs: { type: "number" },
                              on: { input: _vm.updateResultData },
                              model: {
                                value: linkItem.addFromPage,
                                callback: function ($$v) {
                                  _vm.$set(linkItem, "addFromPage", $$v)
                                },
                                expression: "linkItem.addFromPage",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass:
                          "d-flex justify-content-center align-items-end mb-3",
                      },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.removeLink(index)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fas fa-trash" })]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "d-flex justify-content-end mt-3 mb-3" },
        [
          _c(
            "b-button",
            { attrs: { variant: "primary" }, on: { click: _vm.addLink } },
            [_vm._v("\n      Add\n    ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }